<div class="live-video-container item-center overflow-hidden" #playerVideoContainer>
  <div
    class="message bg-brand-gold-1 py-5 text-brand-gray-1"
    *ngIf="mode === modeType.Paused; else streamSection"
  >
    <h1 class="text-center">Game Paused</h1>
  </div>

  <ng-template #streamSection>
    <app-success-alert
      class="message-result message"
      (close)="closeMessage()"
      title="Congratulation!"
      [message]="'+' + playerBetResult?.earnedChips || ''"
      [show]="showWinnerMessage"
    ></app-success-alert>

    <!-- <video
      autoplay
      loop
      muted
      controls
      webkit-playsinline
      playsinline
      #inbetween_video
      id="inbetween_video"
      [controls]="true"
      [autoplay]="true"
      [muted]="true"
    ></video> -->
    <iframe
      *ngIf="_playerService.streamUrl"
      frameborder="0"
      allowfullscreen
      [width]="clientWidth"
      [height]="clientHeight"
      #inbetween_video
      [src]="_playerService.streamUrl"
    >
    </iframe>
  </ng-template>
</div>
